/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const navItemStyle = {
  navItem: (theme: Theme) => ({
    [theme.breakpoints.up("lg")]: {
      height: "100%",
    }
  }),
};
